import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Menu, MenuItem } from '@mui/material';

import { Button } from '../Button';
import { KeyboardArrowDown } from '../Icon';

interface IDropdownProps {
    buttonText: string;
    options: { label: string }[];
    onOptionClick: (label: string) => void;
}

export const Dropdown = ({ buttonText, options, onOptionClick }: IDropdownProps) => {
    const [t] = useTranslation();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <Button
                variant="outlined"
                onClick={handleOpen}
                endIcon={<KeyboardArrowDown />}
            >
                {buttonText}
            </Button>
            <Menu
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            >
                {options.map(option => {
                    return (
                        <MenuItem
                            key={option.label}
                            onClick={() => onOptionClick(option.label)}
                        >
                            {t(option.label)}
                        </MenuItem>
                    );
                })}
            </Menu>
        </>
    );
};
